/** Телефон: одна маска, одна проверка, одна ссылка — на всё приложение.
 *
 * Раньше корзина клиента вела номер по маске, а ручная заявка менеджера
 * принимала любой текст: одни и те же данные жили по разным правилам.
 * Здесь правила общие, а сервер всё равно нормализует своё — фронт лишь
 * помогает набрать, а не решает.
 */

/** Полный белорусский номер: «+375 XX NNNNNNN». */
export const PHONE_FULL = /^\+375 \d{2} \d{7}$/;

/** Привести ввод к маске прямо во время набора.
 *
 * Люди печатают как привыкли: 80291234567, 375291234567, просто 291234567.
 * Цифры одни и те же — форма разная; пустой ввод остаётся пустым, иначе
 * поле нельзя было бы очистить.
 */
export function shapePhone(raw: string): string {
  let digits = (raw || '').replace(/\D/g, '');
  if (digits.startsWith('80')) digits = `375${digits.slice(2)}`;
  if (digits.startsWith('375')) digits = digits.slice(3);
  digits = digits.slice(0, 9);
  if (!digits) return '';
  const code = digits.slice(0, 2);
  const rest = digits.slice(2);
  return `+375 ${code}${rest ? ` ${rest}` : ''}`;
}

/** Номер слитно — для ссылки набора: «+375291234567». */
export function phoneDigits(phone: string): string {
  const digits = (phone || '').replace(/\D/g, '');
  return digits ? `+${digits}` : '';
}

/** href для набора: пустой номер ссылкой не притворяется. */
export function telHref(phone: string): string | undefined {
  const compact = phoneDigits(phone);
  return compact ? `tel:${compact}` : undefined;
}
